/* Generated file. Do not modify. Please check more details in build/generate.ts */
import * as React from "react";
import type { IconProps } from "../IconTypes";
import { IconWrapper } from "../IconWrapper";
export function ConnectionIcon(props: IconProps) {
    return (<IconWrapper {...props}>
            {<path d="M27.831 6.77 23.02 18.03h6.998c.813 0 1.563.5 1.875 1.25.25.814.062 1.69-.562 2.253L15.334 35.545c-.75.563-1.75.626-2.5.063a1.945 1.945 0 0 1-.686-2.377l4.81-11.26h-6.935c-.875 0-1.625-.5-1.875-1.252-.312-.813-.125-1.689.5-2.252L24.645 4.455c.75-.563 1.75-.626 2.499-.063.75.5 1.062 1.502.687 2.377"/>}
        </IconWrapper>);
}
